import { render, staticRenderFns } from "./PaymentSection.vue?vue&type=template&id=702c5563&"
import script from "./PaymentSection.vue?vue&type=script&lang=js&"
export * from "./PaymentSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports